import { Injectable, inject } from '@angular/core';
import { Observable, shareReplay, tap } from 'rxjs';
import { URLS } from 'src/app/core/constants/ConstantVariables';
import { Environment } from 'src/app/environment/environment';
import { GenericService } from 'src/app/services/generic/generic.service';
import { AddEmployeeAcknowledgement, AddEmployeeConsent, AddEmployeeSignature, SignAlertDocument } from '../models/alerts';

@Injectable({
  providedIn: 'root'
})
export class AlertsService{
    private readonly genericService = inject(GenericService);

    public environment: Environment = new Environment();
    URLS: typeof URLS = URLS;
    Controller: string = '';
    TaxController: string = '';
    private ShownOtherAlerts = true;
    private ShownMandatoryAlerts = false;

    setHasShownOtherAlerts(shown: boolean) {
      this.ShownOtherAlerts = shown;
    }

    getHasShownOtherAlerts(): boolean {
      return this.ShownOtherAlerts;
    }

    setHasShownMandatoryAlerts(shown: boolean) {
      this.ShownMandatoryAlerts = shown;
    }

    getHasShownMandatoryAlerts(): boolean {
      return this.ShownMandatoryAlerts;
    }

    private UrlAfterMandatoryAlerts: string | null = null;

    setUrlAfterMandatoryAlerts(url: string | null) {
      this.UrlAfterMandatoryAlerts = url;
    }

    getUrlAfterMandatoryAlerts(): string | null {
      return this.UrlAfterMandatoryAlerts;
    }

    constructor() {
      this.Controller = this.URLS.Controller.Alerts.Name;
    }

    GetAlerts(employeeId:number):Observable<any>{
        return this.genericService.getData(
            this.Controller
            +this.URLS.Controller.Alerts.GetAlerts
            +`/${employeeId}`)
            .pipe(
                  shareReplay(),
                    tap(
                    (data) => data,
                    (error) => error
                    )
        );
    }
    GetEmployeeAlerts(employeeId:number):Observable<any>{
      return this.genericService.getData(
       this.Controller +
       this.URLS.Controller.Alerts.GetEmployeeAlerts +
       `/${employeeId}`
      )
      .pipe(
       shareReplay(),
       tap(
         (data) => data,
         (error) => error
       )
     );
     }
    UpdateAlertSignature(data:AddEmployeeSignature):Observable<any>{
        return this.genericService.putData(
            this.Controller
            +this.URLS.Controller.Alerts.AddSignature
            ,data)
            .pipe(
                  shareReplay(),
                    tap(
                    (data) => data,
                    (error) => error
                    )
        );
    }
    UpdateAcknowledgement(data:AddEmployeeAcknowledgement):Observable<any>{
       return this.genericService.putData(
        this.Controller
            +this.URLS.Controller.Alerts.AddAcknowledgement
            ,data
       )
       .pipe(
        shareReplay(),
          tap(
          (data) => data,
          (error) => error
          )
       );
    }

    // EN-28846 - saves the signature evidence, then the signed alert document.
    SignAlertDocument(data: SignAlertDocument): Observable<any> {
      return this.genericService
        .postData(this.Controller + this.URLS.Controller.Alerts.SignAlertDocument, data)
        .pipe(
          shareReplay(),
          tap(
            (data) => data,
            (error) => error
          )
        );
    }

    // EN-28846 - retries the signed alert document from the saved evidence.
    RetryAlertDocument(signingRecordGuid: string): Observable<any> {
      return this.genericService
        .postData(this.Controller + this.URLS.Controller.Alerts.RetryAlertDocument + `/${signingRecordGuid}`, {})
        .pipe(
          shareReplay(),
          tap(
            (data) => data,
            (error) => error
          )
        );
    }

    UpdateConsent(data:AddEmployeeConsent):Observable<any>{
       return this.genericService.putData(
        this.Controller
            +this.URLS.Controller.Alerts.AddConsent
            ,data
       )
       .pipe(
        shareReplay(),
          tap(
          (data) => data,
          (error) => error
          )
       );
    }

    GetEmployeeInfo(employeeId: number): Observable<any>{
      return this.genericService.getData(
        this.Controller +
        this.URLS.Controller.Alerts.GetEmployeeInfo +
        `/${employeeId}`
      )
      .pipe(
        shareReplay(),
        tap(
          (data) => data,
          (error) => error
        )
      )
    }

    GetClientInfo(employeeId: number): Observable<any>{
      return this.genericService.getData(
        this.Controller +
        this.URLS.Controller.Alerts.GetClientInfo +
        `/${employeeId}`
      )
      .pipe(
        shareReplay(),
        tap(
          (data) => data,
          (error) => error
        )
      )
    }
}
